import type { ReactNode } from "react";
import CheckCircle from "@/components/ui/CheckCircle";

interface LearningObjectiveCheckItemProps {
  children: ReactNode;
}

/**
 * Check-marked learning-objective row — used by Lernzielfragen and Lernzielaussagen.
 */
const LearningObjectiveCheckItem = ({
  children,
}: LearningObjectiveCheckItemProps) => (
  <li className="flex items-start gap-3">
    <CheckCircle className="mt-0.5" />
    <span className="prose prose-p:inline max-w-full text-base text-primary">
      {children}
    </span>
  </li>
);

export default LearningObjectiveCheckItem;
